export class Alert {
    private readonly elements: NodeListOf<HTMLElement>;

    constructor(elements: NodeListOf<HTMLElement>) {
        this.elements = elements;
        this.init();
    }

    protected onClose(element: HTMLElement): void {
        element.remove();
    }

    public init(): void {
        if (!this.elements.length) return;

        this.elements.forEach((element) => {
            const close = element.querySelector(`.close-btn`);

            if (!close) return;
            close.addEventListener('click', () => this.onClose(element));
        });
    }
}